/**
 * Warns applications using the shared scope if they have packages multiple times
 */
export var warnDuplicatePkg = function (packages) {
    var entries = Object.entries(packages);
    entries.forEach(function (_a) {
        var pkgName = _a[0], versions = _a[1];
        var instances = Object.keys(versions);
        if (instances.length > 1) {
            console.warn("[SCALPRUM]: You have ".concat(pkgName, " package that is being loaded into browser multiple times. You might want to align your version with the chrome one."));
            console.warn("[SCALPRUM]: All packages instances:", versions);
        }
    });
};
//# sourceMappingURL=warnDuplicatePkg.js.map